import React from 'react'
import { 
  TrendingUp, 
  TrendingDown, 
  FolderKanban, 
  CheckSquare, 
  Users, 
  Banknote 
} from 'lucide-react'

const StatsCard = ({ title, value, change, changeType, icon, color = 'blue', loading = false }) => {
  const colorClasses = {
    blue: { bg: 'bg-blue-50', text: 'text-blue-600' },
    green: { bg: 'bg-green-50', text: 'text-green-600' },
    purple: { bg: 'bg-purple-50', text: 'text-purple-600' },
    yellow: { bg: 'bg-yellow-50', text: 'text-yellow-600' },
    red: { bg: 'bg-red-50', text: 'text-red-600' }
  }

  const colors = colorClasses[color] || colorClasses.blue

  const getIcon = () => {
    switch (icon) {
      case 'projects':
        return <FolderKanban className="h-6 w-6" strokeWidth={1.5} />
      case 'tasks':
        return <CheckSquare className="h-6 w-6" strokeWidth={1.5} />
      case 'users':
        return <Users className="h-6 w-6" strokeWidth={1.5} />
      case 'revenue':
        return <Banknote className="h-6 w-6" strokeWidth={1.5} />
      default:
        return <FolderKanban className="h-6 w-6" strokeWidth={1.5} />
    }
  }

  if (loading) {
    return (
      <div className="bg-white rounded-2xl p-6" style={{ border: '0.5px solid #e5e7eb' }}>
        <div className="animate-pulse">
          <div className="flex items-start justify-between mb-4">
            <div className={`${colors.bg} p-3 rounded-xl`}>
              <div className="h-6 w-6 bg-gray-300 rounded"></div>
            </div>
            <div className="h-4 w-12 bg-gray-200 rounded"></div>
          </div>
          <div className="h-3 bg-gray-200 rounded w-2/3 mb-2"></div>
          <div className="h-8 bg-gray-300 rounded w-1/2 mb-2"></div>
          <div className="h-3 bg-gray-200 rounded w-1/3"></div>
        </div>
      </div>
    )
  }

  const isPositive = changeType === 'positive'
  const isNegative = changeType === 'negative'

  return (
    <div 
      className="bg-white rounded-2xl p-6 cursor-pointer transition-all duration-150 hover:shadow-lg"
      style={{ border: '0.5px solid #e5e7eb' }}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`${colors.bg} p-3 rounded-xl`}>
          <div className={colors.text}>
            {getIcon()}
          </div>
        </div>
        {change && (
          <div
            className={`flex items-center gap-1 text-sm font-medium ${
              isPositive ? 'text-green-600' : isNegative ? 'text-red-600' : 'text-gray-500'
            }`}
          >
            {isPositive ? (
              <TrendingUp size={16} />
            ) : isNegative ? (
              <TrendingDown size={16} />
            ) : null}
            {change}
          </div>
        )}
      </div>
      <div className="text-sm text-gray-500 mb-1">{title}</div>
      <div className="text-3xl font-medium text-gray-900">{value}</div>
      {change && (
        <div className="text-xs text-gray-400 mt-2">vs last month</div>
      )}
    </div>
  )
}

export default StatsCard